'use strict';
const angular = require('angular');
const {isFunction, isNumber, isObject, isUndefined} = angular;

export function AbstractEventListenerProvider() {
    let hashId = 0;
    return {
      $get: [
        function () {
          function AbstractEventListener(ListenerClass, config) {
            if (!ListenerClass) return;
            config = isObject(config) ? config : {};

            if (!isFunction(config.callback))
              throw new Error(ListenerClass.name + ': callback must be a function!');
            config.id = isNumber(config.id) ? config.id : hashId++;

            Object.defineProperties(this, {
              id: {configurable: false, enumerable: false, writable: false, value: config.id},
              eventType: {configurable: false, enumerable: false, writable: false, value: config.eventType},
              callback: {configurable: false, enumerable: false, writable: false, value: config.callback},
              context: {configurable: false, enumerable: false, writable: false, value: config.context},
              $$isActive: {configurable: false, enumerable: false, writable: true, value: false},
              $$className: {configurable: false, enumerable: false, writable: false, value: ListenerClass.name},
              $$boundDestroy: {configurable: false, enumerable: false, writable: false, value: this.destroy.bind(this)}
            });

            if (config.start || isUndefined(config.start)) {
              this.start();
            }
          }

          AbstractEventListener.__inheritFrom = __inheritFrom;

          function __inheritFrom(ListenerClass, config) {
            ListenerClass.prototype = new AbstractEventListener();
            ListenerClass.prototype.constructor = AbstractEventListener;

            Object.defineProperties(ListenerClass, {
              EVENT_TYPES: {value: config.eventTypes}
            });

            Object.defineProperties(ListenerClass.prototype, {
              $$create: {value: config.create},
              $$destroy: {value: config.destroy}
            });
          }

          AbstractEventListener.prototype = {};
          AbstractEventListener.prototype.isActive = isActive;
          AbstractEventListener.prototype.isAlive = isAlive;
          AbstractEventListener.prototype.start = start;
          AbstractEventListener.prototype.pause = pause;
          AbstractEventListener.prototype.resume = resume;
          AbstractEventListener.prototype.destroy = destroy;

          function isActive() {
            return this.$$isActive;
          }

          function isAlive() {
            return this.start === throwDestroyedError;
          }

          // initialization logic goes here. on complete, it is replaced with resume.
          function start() {
            if (this.$$isActive) return this.$$boundDestroy;
            this.$$create();
            this.$$isActive = true;

            return this.$$boundDestroy;
          }

          function pause() {
            if (!this.$$isActive) return;
            this.$$destroy();
            this.$$isActive = false;
          }

          function resume() {
            if (this.$$isActive) return;
            this.$$create();
            this.$$isActive = true;
          }

          function destroy() {
            this.$$destroy();
            this.$$isActive = false;
            this.start = this.pause = throwDestroyedError;
          }

          function throwDestroyedError() {
            throw new Error(this.$$className + ': This listener has been destroyed and cannot be resumed!');
          }

          return AbstractEventListener;
        }]
    };
  }


// WEBPACK FOOTER //
// ./src/js/_libs/angular-fire-util/AbstractEventListener.js